import { Flex, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

export const OtpTimer: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState(45); // OTP timer set to 45 seconds
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    // If time runs out, stop the timer
    if (timeLeft <= 0) {
        setIsDisabled(false); // Enable the resend button when time is up
        return;
    }

    // Decrease time left by 1 every second
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(timer);
  }, [timeLeft]);

  const resetTimer = () => {
    setIsDisabled(true);
    setTimeLeft(45); // Reset the timer to 45 seconds
  };

  return (
    <Flex margin="0.5rem" justifyContent= "space-between" alignItems= "flex-start" alignSelf="stretch">
        <Text color="#4AAD52">{timeLeft > 0 ? `${timeLeft} s` : "" }</Text>
        <Text
            fontSize="lg"
            color={isDisabled ? 'gray.500' : '#08090A'}
            cursor={isDisabled ? 'not-allowed' : 'pointer'}
            _hover={{
                color: !isDisabled ? '#FF7E6B' : 'gray.500',
                textDecoration: !isDisabled ? 'underline' : 'none',
            }}
            onClick={!isDisabled ? resetTimer : undefined}
        >
            Resend OTP
        </Text>
    </Flex>
  );
};

